import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const SourceOfFundsWrapper = styled('div', { label: 'SourceOfFundsWrapper' })`
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-family: var(--font-family-primary);
`;

export const SourceOfFundsDescription = styled('p', { label: 'SourceOfFundsDescription' })`
    margin: 0;
    font-size: 14px;
    line-height: 1.43;
    color: ${mainColors.grays.gray500};
`;

export const SourceOfFundsSection = styled('section', { label: 'SourceOfFundsSection' })`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    border: 1px solid ${mainColors.grays.gray200};
    border-radius: 8px;
    background-color: ${mainColors.default.light};
`;

export const SourceOfFundsSectionTitle = styled('h3', { label: 'SourceOfFundsSectionTitle' })`
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.43;
    color: ${mainColors.main.primary};
`;

export const SourceOfFundsFieldRow = styled('div', { label: 'SourceOfFundsFieldRow' })`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    line-height: 1.43;
    color: ${mainColors.main.primary};
`;

export const SourceOfFundsAmountInput = styled('input', { label: 'SourceOfFundsAmountInput' })<{ $hasError?: boolean }>`
    width: 140px;
    padding: 8px 12px;
    border: 1px solid ${({ $hasError }): string => ($hasError === true ? mainColors.status.error : mainColors.grays.gray200)};
    border-radius: 6px;
    font-size: 14px;
    line-height: 1.43;
    color: ${mainColors.main.primary};
    background-color: ${mainColors.default.light};

    &:focus {
        outline: none;
        border-color: ${({ $hasError }): string =>
            $hasError === true ? mainColors.status.error : mainColors.grays.gray400};
    }
`;

export const SourceOfFundsFieldError = styled('span', { label: 'SourceOfFundsFieldError' })`
    display: block;
    min-height: 17px;
    font-size: 12px;
    line-height: 1.43;
    color: ${mainColors.status.error};
`;

export const SourceOfFundsFieldCell = styled('div', { label: 'SourceOfFundsFieldCell' })`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const SourceOfFundsSelectorWrapper = styled('div', { label: 'SourceOfFundsSelectorWrapper' })`
    min-width: 160px;
`;

export const SourceOfFundsSwitchRow = styled('div', { label: 'SourceOfFundsSwitchRow' })`
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 14px;
    line-height: 1.43;
    color: ${mainColors.main.primary};
`;

export const SourceOfFundsPanelWrapper = styled('div', { label: 'SourceOfFundsPanelWrapper' })<{ $isVisible: boolean }>`
    display: grid;
    grid-template-rows: ${({ $isVisible }): string => ($isVisible ? '1fr' : '0fr')};
    margin-top: -4px;
    transition: grid-template-rows 0.3s ease;
`;

export const SourceOfFundsPanelInner = styled('div', { label: 'SourceOfFundsPanelInner' })`
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow: hidden;
    min-height: 0;
`;

export const SourceOfFundsActionOptions = styled('div', { label: 'SourceOfFundsActionOptions' })`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const SourceOfFundsActionBlock = styled('div', { label: 'SourceOfFundsActionBlock' })`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SourceOfFundsActionOption = styled('label', { label: 'SourceOfFundsActionOption' })`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    line-height: 1.43;
    color: ${mainColors.main.primary};
    cursor: pointer;
`;

export const SourceOfFundsActionLabel = styled('div', { label: 'SourceOfFundsActionLabel' })`
    margin-left: 10px;
`;

export const SourceOfFundsRestrictionPeriodPanel = styled('div', { label: 'SourceOfFundsRestrictionPeriodPanel' })`
    margin-left: 28px;
    padding: 12px 16px;
    border: 1px solid ${mainColors.grays.gray200};
    border-radius: 8px;
    background-color: ${mainColors.grays.gray100};
    max-width: 320px;
`;

export const SourceOfFundsRestrictionPeriodField = styled('div', { label: 'SourceOfFundsRestrictionPeriodField' })`
    display: flex;
    flex-direction: column;
    gap: 6px;

    > div {
        margin-bottom: 0;
    }
`;

export const SourceOfFundsRestrictionPeriodFieldLabel = styled('span', { label: 'SourceOfFundsRestrictionPeriodFieldLabel' })`
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    color: ${mainColors.main.primary};
`;

export const SourceOfFundsRequiredMark = styled('span', { label: 'SourceOfFundsRequiredMark' })`
    color: ${mainColors.status.error};
`;

export const SourceOfFundsActions = styled('div', { label: 'SourceOfFundsActions' })`
    display: flex;
    justify-content: flex-start;
    gap: 12px;
`;

export const SourceOfFundsTestTriggerField = styled('div', { label: 'SourceOfFundsTestTriggerField' })`
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 320px;
`;

export const SourceOfFundsTestTriggerLabel = styled('label', { label: 'SourceOfFundsTestTriggerLabel' })`
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    color: ${mainColors.main.primary};
`;

export const SourceOfFundsTestTriggerInput = styled('input', { label: 'SourceOfFundsTestTriggerInput' })`
    width: 100%;
    padding: 8px 12px;
    border: 1px solid ${mainColors.grays.gray200};
    border-radius: 6px;
    font-size: 14px;
    line-height: 1.43;
    color: ${mainColors.main.primary};
    background-color: ${mainColors.default.light};

    &:focus {
        outline: none;
        border-color: ${mainColors.grays.gray400};
    }
`;
